(function ($) {

    $(document).ready(function () {

        'use strict';


        // basic hide and show forms
        $(".logIn").on("click", function () {

            $(".popbackground").hide();
            $(".modal").hide();

            $(".ex2-popbackground").show();
            $("#ex2").show();
        });

        $(".signUp").on("click", function () {
            $(".popbackground").hide();
            $(".modal").hide();

            $(".ex3-popbackground").show();
            $("#ex3").show();
        });

        $(".resetPassword").on("click", function () {
            console.log('test');
            $(".popbackground").hide();
            $(".modal").hide();

            $(".ex4-popbackground").show();
            $("#ex4").show();
        });


        $(".close-modal").on("click", function () {

            $(".popbackground").hide();
            $(".modal").hide();
        });


        // Login, Reset Password, Signup


            $("#signup_form").submit(function (event) {
                event.preventDefault();

                $('#signUpFormError').hide().text('');

                $.ajax({
                    type: "POST",
                    url: "../functions/member/signup.php",
                    dataType: "json",
                    data: $(this).serialize(),
                    success: function (data) {


                        if (data.result === 'success') {

                            setTimeout(function(){
                                console.log('double true');
                                window.location.replace("https://bestutahrealestate.com/members/saved-homes");
                            }, 1000);

                        } else {
                            $("#csrfSignUp").val(data.token);
                            $('#signUpFormError').show().append(data.errors);
                        }
                    },
                    error: function () {
                        $("#csrfSignUp").val(data.token);
                        $('#signUpFormError').show().append(data.errors);
                    }
                });
                return false;
            });



        $("#pw_reset_form").submit(function (event) {
            $('#passwordResetInfo').hide().text('');
            event.preventDefault();

            $.ajax({
                type: "POST",
                url: "../functions/member/resetpassword.php",
                dataType: "json",
                data: $(this).serialize(),
                success: function (data) {

                    if (data.result === 'success') {
                        $('#passwordResetInfo').show().append('Email Sent check your mailbox.');

                    } else {
                        $("#csrfPassword").val(data.token);
                        $('#passwordResetInfo').show().append(data.errors);
                    }
                },
                error: function () {
                    $("#csrfPassword").val(data.token);
                    $('#passwordResetInfo').show().append(data.errors);
                }
            });
            return false;
        });


        $("#login_form").submit(function (event) {
            $('#loginUpFormError').hide().text('');
            event.preventDefault();

            $.ajax({
                type: "POST",
                url: "../functions/member/login.php",
                dataType: "json",
                data: $(this).serialize(),
                success: function (data) {
                    $("#csrfLogin").val(data.token);
                    if (data.result === 'success') {
                        $('#loginUpFormError').show().append('Success! Your now logged in.');
                        window.location.replace("https://bestutahrealestate.com/members/saved-homes");

                    } else {
                        $('#loginUpFormError').show().append(data.errors);
                    }
                },
                error: function () {
                    $('#loginUpFormError').show().append(data.errors);
                }
            });
            return false;
        });

    });


})(jQuery);










